(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const heroSwiper = new Swiper('.myHeroSwiper', {
      loop: true,
      speed: 1200,
      effect: 'fade',
      fadeEffect: { crossFade: true },

      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      on: {
        slideChangeTransitionEnd: function () {
          AOS.refreshHard();
        },
      },
    });

    AOS.init({
      once: true,
      duration: 800,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
